import { profileConstants } from '../constants'

const initialState = {
  roles: null,
  // roleid: null,
  // permission: null,
  // canExport: null,
  // privacyMode: null,
  loading: false,
  error: null
}

export default function profile (state = initialState, action) {
  switch (action.type) {
    case profileConstants.LOAD_PROFILE:
      return { ...state,
        loading: true
      }
    case profileConstants.LOAD_PROFILE_SUCCESS:
      return { ...state,
        ...action.payload,
        loading: false,
        error: null
      }
    case profileConstants.LOAD_PROFILE_FAILURE:
      return { ...state,
        error: action.payload,
        loading: false
      }
    case profileConstants.PASSWORD_UPDATED:
      return { ...state, loading: false }
    case profileConstants.UPDATING_PASSWORD:
      return { ...state, loading: true }
    case profileConstants.CHANGING_ROLE:
      return { ...state, loading: true }
    default:
      return state
  }
}
